import { useLazyQuery } from '@apollo/client';
import { useAtom } from 'jotai/index';
import { useCallback } from 'react';
import { DefaultIdentifierDocument } from '~/graphql/__generated__/graphql';
import { useConfigurator } from '~/graphql/hooks/use-configurator';
import { state } from '~/storage';
import { normalizeCarIdentifier } from '~/app/utils/normalizeCarIdentifier';

function useDefaultIdentifierLazyQuery() {
	const [fetchDefaultIdentifiers, { loading }] = useLazyQuery(DefaultIdentifierDocument, {
		returnPartialData: true,
		fetchPolicy: 'no-cache',
	});

	return { fetchDefaultIdentifiers, loading };
}

export function useGetDefaultIdentifer() {
	const { carIdentifier } = useConfigurator();
	const [defaultIdentifer, setDefaultIdentifier] = useAtom(state.defaultIdentifier);
	const { fetchDefaultIdentifiers } = useDefaultIdentifierLazyQuery();

	const getDefaultIdentifier = useCallback(async () => {
		if (!defaultIdentifer || defaultIdentifer?.length < 1) {
			try {
				const result = await fetchDefaultIdentifiers({
					variables: {
						configuredCar: carIdentifier,
					},
				});
				if (result.data?.configuredCar?.carlineStructureCarline?.trimlines) {
					const ids =
						result.data.configuredCar?.carlineStructureCarline?.trimlines
							?.flatMap((a) =>
								a.models.map((b) =>
									b.defaultConfiguredCar?.id
										? normalizeCarIdentifier(b.defaultConfiguredCar?.id)
										: undefined,
								),
							)
							.filter(Boolean) || [];
					setDefaultIdentifier(ids);
				}
			} catch (error) {
				console.error('Error fetching default identifiers:', error);
			}
		}
	}, []);

	return { getDefaultIdentifier };
}
